module.exports = __webpack_public_path__ + "img/status-team-fulled.0b8d59ef.png";